
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(([48]72|638)6|3565|5181|6127|9639|9867)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
